<template>
  <modal title="Escalate Post" ref="modal">
    <form class="q-gutter-md">
      <h2 class="text-subtitle2">Share Post (Optional)</h2>
      <q-input
        v-model="keyword"
        placeholder="Search by name or email"
        autocomplete="no"
        debounce="750"
        clearable
        clear-icon="fa fa-times"
        dense filled
      >
        <template v-slot:prepend>
          <q-icon name="fa fa-search" size="xs" color="primary" />
        </template>
      </q-input>
      <users-list
        :account-id="post.client.customerId"
        :keyword="keyword"
        :selected="recipients"
        exclude-self
        @selection="recipients = $event"
      />
      <p v-show="recipients.length">
        <strong>Sharing with:</strong> {{ sharingWith }}
      </p>
      <q-input
        v-show="recipients.length"
        label="Message (Optional)"
        placeholder="E.g. Hey, please check this post out."
        type="textarea"
        v-model="message"
        outlined
      />
    </form>
    <template v-slot:actions>
      <!-- Button ID is REQUIRED for Google Tag Manager -->
      <async-btn
        label="Escalate"
        color="warning"
        :task="task"
        id="escalate-post-btn"
        @click="escalate" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Post, DetailedUser, Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import UsersList from '@/user/UsersList.vue';
import { escalate } from '../post';

interface Data {
  keyword: string|null,
  recipients: DetailedUser[],
  message: string|null,
  task: Promise<Post>|null
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    UsersList,
    AsyncBtn,
  },
  props: {
    post: {
      type: Object as () => Post,
      required: true,
    },
  },
  data(): Data {
    return {
      keyword: null,
      recipients: [],
      message: null,
      task: null,
    };
  },
  computed: {
    recipientIds(): number[] {
      return this.recipients.map(r => r.id);
    },
    sharingWith(): string {
      return this.recipients.map(u => `${u.firstName} ${u.lastName}`).join(', ');
    },
  },
  methods: {
    escalate() {
      this.task = escalate(this.post, this.recipientIds, this.message);
      this.task.then((post: Post) => {
        this.$emit('ok', post);
        (this.$refs.modal as ModalElement).hide();
        notify('Post escalated.');
      });
    },
  },
});
</script>
